import React from 'react'
import HeaderImage from '../assets/Executive Management.jpeg'
import Navigation from '../navbar'
import Asmah from '../assets/leadership/yvonne.png'
import Footer from '../footer'
import { useNavigate } from 'react-router-dom';


function Leadership() {
    let navigate = useNavigate();

    const Management = () => {
        navigate("/robertasmah")
    }

    const ExecuManagement = () => {
        navigate("/leadership")
    }
    return (

        <>

            <Navigation />

            <div className="relative">
                <div className="absolute inset-0 bg-black bg-opacity-50 flex">
                    <h1 className="font-fjalla text-white text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:mt-24 lg:m-10 xl:text-6xl xl:mx-[270px]">

                    </h1>
                </div>
                <img
                    className="w-full h-auto xs:w-full xs:h-[200px] xs:object-cover sm:w-full sm:h-[300px] md:w-full md:h-[400px] md:object-cover lg:w-full lg:h-[500px] xl:w-full xl:"
                    src={HeaderImage}
                    alt="Ghana Gas GPP"
                />
            </div>

            <h1 className="font-fjalla text-gasblue text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10 phone:hidden md:block  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:m-10 xl:text-5xl xl:mx-[270px] xl:mt-[100px] hover:cursor-pointer" onClick={ExecuManagement}>
                Executive Management
            </h1>

            <div class="grid phone:grid-cols-2 md:grid-cols-3 gap-4">
                <div class="col-span-1 flex items-start justify-end">
                    <img src={Asmah} alt="CEO Image" className='scale-75' />
                </div>
                <div class="col-span-2 flex items-center">
                    <div>
                        <p class="text-black font-fjalla text-[24px] md:mx-20 phone:mx-10 ">Ms. Yvonne Ama Adiepena Wiredu-Akpabli </p>
                        <p class="text-black font-fira text-[20px] md:mx-20 phone:mx-10 ">General Manager, Human Resource</p>
                        <br />
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10  text-justify leading-snug">
                        Yvonne is a seasoned Strategic HR and training expert with over 19 years of proven experience in building, transforming, and leading human capital functions across diverse sectors, including the public sector, financial services, NGOs, telecoms, media, healthcare, and multinational organizations. Her career is defined by a rare combination of deep strategic HR leadership, strong legal grounding, and a passion for developing people and organizations for sustained performance and growth.                            </p>  <br />
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10  text-justify leading-snug">
                        She specializes in repositioning HR from a transactional function into a strategic business partner that drives organizational results. With a degree and Master of Laws (LLB and LLM in Labour Law) and professional HR certifications, she brings a strong compliance, governance, and ethical lens to her work. She is particularly recognized for her ability to build HR departments from the ground up, design performance management systems, develop robust HR policies, structure competitive reward systems, and support executive decision-making with people data and insights.</p>  <br />
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10  text-justify leading-snug">
                        Beyond HR, Yvonne is a dynamic facilitator; she designs and delivers high-impact training programmes that bridge theory and real-world application. Her facilitation style is practical, engaging, and deeply rooted in the African and Ghanaian business context.</p>  <br />
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10  text-justify leading-snug">
                        Yvonne previously led HR and Administration at MSC Shipping, Databank Group, and Class Media Group. She is a Certified Professional Coach, a Fellow of the Chartered Institute of Human Resource Management Practitioners (Ghana), and a SPHR.</p>  <br />

                    </div>
                </div>
            </div>
            <br />

            <Footer />
        </>
    )

}

export default Leadership;